// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3P5ik","additionalInfo":"AgreementModal_additionalInfo__19zHq"};